import React, { useEffect, useState,useRef } from "react";
import { setTitle } from "../helpers/MetaTag";
import Button from "../components/form/Button";
import Input from "../components/form/Input";
import Checkbox from "../components/form/Checkbox";
import Textarea from "../components/form/Textarea";
import toastr from "toastr";
import { postData } from "../services/api";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Editor } from "@tinymce/tinymce-react";
import { tinymceApiKey } from "../helpers";

const ManageEmergencyReplacementPlan = () => {
  setTitle("Succession Now | Emergency/Interim Replacement Policy & Plan");
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [involuntaryTermination, setInvoluntaryTermination] = useState("");
  const [voluntaryTermination, setVoluntaryTermination] = useState("");
  const [voluntaryTerminationOptions, setVoluntaryTerminationOptions] = useState([{ title: "", description: "" }]);
  const [actionPlan, setActionPlan] = useState([
    {
      title: "",
      subTitle: [
        {
          responsibility: "",
          responsible_party: "",
        },
      ],
    },
  ]);
  const [externalRecruitment, setExternalRecruitment] = useState("");
  const [externalRecruitmentOptions, setExternalRecruitmentOptions] = useState([
    {
      title: "",
      isResponsibility: false,
      subTitle: [
        {
          responsibility: "",
          responsible_party: "",
        },
      ],
    },
  ]);
  const [guidelines, setGuidelines] = useState([""]);
  const [details, setDetails] = useState({});
  const [id, setId] = useState("");
  const [isManage, setIsManage] = useState(false);
  const editorRef = useRef(null);

  const addRow = async () => {
    setVoluntaryTerminationOptions([...voluntaryTerminationOptions, { title: "", description: "" }]);
  };
  const removeRow = async (position) => {
    voluntaryTerminationOptions.splice(position, 1);
    setVoluntaryTerminationOptions(
      voluntaryTerminationOptions.map((it, idx) => {
        return it;
      })
    );
  };
  const handelUpdate = async (value, field, position) => {
    voluntaryTerminationOptions[position][field] = value;
    setVoluntaryTerminationOptions(
      voluntaryTerminationOptions.map((it, idx) => {
        if (idx === position) {
          return {
            ...it,
            [field]: value,
          };
        } else {
          return it;
        }
      })
    );
  };

  const addActionRow = async () => {
    setActionPlan([
      ...actionPlan,
      {
        title: "",
        subTitle: [
          {
            responsibility: "",
            responsible_party: "",
          },
        ],
      },
    ]);
  };

  const removeActionRow = async (index) => {
    actionPlan.splice(index, 1);
    setActionPlan(
      actionPlan.map((it, idx) => {
        return it;
      })
    );
  };

  const handelActionUpdate = async (value, field, index) => {
    actionPlan[index][field] = value;
    setActionPlan(
      actionPlan.map((it, idx) => {
        if (idx === index) {
          return {
            ...it,
            [field]: value,
          };
        } else {
          return it;
        }
      })
    );
  };

  const addSubActionRow = async (index) => {
    setActionPlan(
      actionPlan.map((itm, idx) => {
        if (idx === index) {
          return {
            ...itm,
            subTitle: [
              ...itm?.subTitle,
              {
                responsibility: "",
                responsible_party: "",
              },
            ],
          };
        } else {
          return itm;
        }
      })
    );
  };

  const removeSubActionRow = async (index, key) => {
    actionPlan[index].subTitle.splice(key, 1);
    setActionPlan(
      actionPlan.map((it, idx) => {
        if (idx === index) {
          return {
            ...it,
            subTitle: [...it?.subTitle],
          };
        } else {
          return it;
        }
      })
    );
  };

  const handelSubActionUpdate = async (index, value, field, key) => {
    actionPlan[index].subTitle[field] = value;
    setActionPlan(
      actionPlan.map((it, idx) => {
        if (idx === index) {
          let sub = it.subTitle.map((i, k) => {
            if (k === key) {
              return {
                ...i,
                [field]: value,
              };
            } else {
              return i;
            }
          });
          return {
            ...it,
            subTitle: sub,
          };
        } else {
          return it;
        }
      })
    );
  };

  const addExternalRecruitmentRow = async () => {
    setExternalRecruitmentOptions([
      ...externalRecruitmentOptions,
      {
        title: "",
        subTitle: [
          {
            responsibility: "",
            responsible_party: "",
          },
        ],
      },
    ]);
  };

  const removeExternalRecruitmentRow = async (index) => {
    externalRecruitmentOptions.splice(index, 1);
    setExternalRecruitmentOptions(
      externalRecruitmentOptions.map((it, idx) => {
        return it;
      })
    );
  };

  const handelExternalRecruitmentUpdate = async (value, field, index) => {
    externalRecruitmentOptions[index][field] = value;
    setExternalRecruitmentOptions(
      externalRecruitmentOptions.map((it, idx) => {
        if (idx === index) {
          return {
            ...it,
            [field]: value,
          };
        } else {
          return it;
        }
      })
    );
  };

  const addSubExternalRecruitmentRow = async (index) => {
    setExternalRecruitmentOptions(
      externalRecruitmentOptions.map((itm, idx) => {
        if (idx === index) {
          return {
            ...itm,
            subTitle: [
              ...itm?.subTitle,
              {
                responsibility: "",
                responsible_party: "",
              },
            ],
          };
        } else {
          return itm;
        }
      })
    );
  };

  const removeSubExternalRecruitmentRow = async (index, key) => {
    externalRecruitmentOptions[index].subTitle.splice(key, 1);
    setExternalRecruitmentOptions(
      externalRecruitmentOptions.map((it, idx) => {
        if (idx === index) {
          return {
            ...it,
            subTitle: [...it?.subTitle],
          };
        } else {
          return it;
        }
      })
    );
  };

  const handelSubExternalRecruitmentUpdate = async (index, value, field, key) => {
    externalRecruitmentOptions[index].subTitle[field] = value;
    setExternalRecruitmentOptions(
      externalRecruitmentOptions.map((it, idx) => {
        if (idx === index) {
          let sub = it.subTitle.map((i, k) => {
            if (k === key) {
              return {
                ...i,
                [field]: value,
              };
            } else {
              return i;
            }
          });
          return {
            ...it,
            subTitle: sub,
          };
        } else {
          return it;
        }
      })
    );
  };

  const handelCheckbox = async (index, event) => {
    setExternalRecruitmentOptions(
      externalRecruitmentOptions.map((it, idx) => {
        if (idx === index) {
          return {
            ...it,
            isResponsibility: event.target.checked,
          };
        } else {
          return it;
        }
      })
    );
  };

  const addGuidelinesRow = async () => {
    setGuidelines([...guidelines, ""]);
  };

  const removeGuidelinesRow = async (index) => {
    guidelines.splice(index, 1);
    setGuidelines(
      guidelines.map((it) => {
        return it;
      })
    );
  };

  const handelGuidelines = async (value, index) => {
    guidelines[index] = value;
    setGuidelines(
      guidelines.map((it, idx) => {
        if (idx === index) {
          return value;
        } else {
          return it;
        }
      })
    );
  };

  useEffect(() => {
    const detailsFun = async () => {
      try {
        const result = await postData("emergency-replacement/details", {});
        if (result.data) {
          setDetails(result.data);
        }
      } catch (err) {
        console.log(err.message);
      }
    };
    detailsFun();
  }, []);

  useEffect(() => {
    if (Object.keys(details).length > 0) {
      setId(details?._id);
      setInvoluntaryTermination(details?.involuntary_termination);
      setVoluntaryTermination(details?.voluntary_termination);
      setVoluntaryTerminationOptions(details?.voluntary_ermination_options);
      setActionPlan(details?.action_plan);
      setExternalRecruitment(details?.external_recruitment);
      setExternalRecruitmentOptions(details?.external_recruitment_options);
      setGuidelines(details?.guidelines);
    }
  }, [details]);

  const onSubmit = async (e) => {
    setIsManage(true);
    try {
      let path = "";
      let payload = "";
      if (id) {
        path = "emergency-replacement/update";
        payload = {
          id: id,
          involuntary_termination: involuntaryTermination,
          voluntary_termination: voluntaryTermination,
          voluntary_ermination_options: voluntaryTerminationOptions,
          action_plan: actionPlan,
          external_recruitment: externalRecruitment,
          external_recruitment_options: externalRecruitmentOptions,
          guidelines: guidelines,
        };
      } else {
        path = "emergency-replacement/create";
        payload = {
          involuntary_termination: involuntaryTermination,
          voluntary_termination: voluntaryTermination,
          voluntary_ermination_options: voluntaryTerminationOptions,
          action_plan: actionPlan,
          external_recruitment: externalRecruitment,
          external_recruitment_options: externalRecruitmentOptions,
          guidelines: guidelines,
        };
      }

      const result = await postData(path, payload);
      if (result.status && result.status === 200) {
        toastr.success(result.message);
        setIsManage(false);
        return navigate("/emergency-replacement-plan");
      } else {
        toastr.error(result.message);
        setIsManage(false);
      }
    } catch (error) {
      toastr.error(error.message);
      setIsManage(false);
    }
  };

const ActionButton = ({ isAdd, onClick, disabled = false }) => (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`inline-flex items-center justify-center w-8 h-8 rounded-full transition-all duration-200 ${
        isAdd
          ? 'bg-teal-500 hover:bg-teal-600 text-white hover:shadow-lg hover:scale-110'
          : 'bg-rose-500 hover:bg-rose-600 text-white hover:shadow-lg hover:scale-110'
      } ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
    >
      <i className={`fa-light ${isAdd ? 'fa-plus' : 'fa-minus'} text-sm`}></i>
    </button>
  );
  
  return (
    <>
      {/* Enhanced Header */}
      <div className="relative mb-8">
        <div className="bg-gradient-to-r from-teal-500 to-teal-600 rounded-xl p-6 text-white">
          <div className="flex items-center">
            <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mr-4">
              <i className="fa-light fa-shield-exclamation text-2xl"></i>
            </div>
            <div>
              <h1 className="text-2xl md:text-3xl font-bold mb-1">
                {t("emergency_interim_replacement_policy_&_plan")}
              </h1>
              <p className="text-teal-100 text-sm">
                {t("create_comprehensive_emergency_plan", "Create a comprehensive emergency replacement plan for key positions")}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="space-y-8">
        {/* Termination Policies Section */}
        
        <div className={`bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden`}>
            <div className="bg-gradient-to-r from-teal-500 to-teal-600 px-6 py-4">
                <h3 className="text-white font-semibold text-lg flex items-center">
                <i className={`fa-light fa-file-contract mr-3 text-xl`}></i>
                {t("termination_policies", "Termination Policies")}
                </h3>
            </div>
            <div className="p-6 space-y-6">
                <div className="space-y-6">
                    {/* Involuntary Termination */}
                    <div className="bg-slate-50 rounded-lg p-4">
                    <div className="flex items-center mb-4">
                        <div className="w-8 h-8 bg-rose-100 rounded-full flex items-center justify-center mr-3">
                        <i className="fa-light fa-user-xmark text-rose-600"></i>
                        </div>
                        <h4 className="font-semibold text-slate-800">{t("involuntary_termination")}</h4>
                    </div>
                    <Textarea 
                        label="" 
                        labelClasses={"!text-sm font-medium"} 
                        inputValue={involuntaryTermination} 
                        inputPlaceholder={t("enter_details")} 
                        setTextarea={setInvoluntaryTermination}
                    />
                    </div>

                    {/* Voluntary Termination */}
                    <div className="bg-slate-50 rounded-lg p-4">
                    <div className="flex items-center mb-4">
                        <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mr-3">
                        <i className="fa-light fa-user-check text-blue-600"></i>
                        </div>
                        <h4 className="font-semibold text-slate-800">{t("voluntary_termination")}</h4>
                    </div>
                    <Textarea 
                        label="" 
                        labelClasses={"!text-sm font-medium"} 
                        inputValue={voluntaryTermination} 
                        inputPlaceholder={t("enter_details")} 
                        setTextarea={setVoluntaryTermination}
                    />
                    </div>

                    {/* Voluntary Termination Options */}
                    <div className="border-l-4 border-teal-500 pl-4">
                    <h4 className="font-semibold text-slate-800 mb-4 flex items-center">
                        <i className="fa-light fa-list-check mr-2 text-teal-600"></i>
                        {t("voluntary_termination_options", "Voluntary Termination Options")}
                    </h4>
                    
                    {voluntaryTerminationOptions &&
                        voluntaryTerminationOptions.map((row, key) => (
                        <div key={key} className="bg-white rounded-lg border border-slate-200 p-4 mb-4 hover:shadow-md transition-shadow duration-200">
                            <div className="grid sm:grid-cols-2 gap-4 relative pr-8 sm:pr-10">
                                <div className="w-full">
                                    <Input 
                                        label={key === 0 ? t("title") : ""} 
                                        labelClasses={"!text-sm font-medium text-slate-700"} 
                                        inputType={"text"} 
                                        inputPlaceholder={t("enter_title")} 
                                        inputValue={row?.title} 
                                        setInput={(val) => handelUpdate(val, "title", key)}
                                    />
                                </div>
                                <div className="w-full">
                                    <Textarea 
                                        label={key === 0 ? t("description") : ""} 
                                        labelClasses={"!text-sm font-medium text-slate-700"} 
                                        inputValue={row?.description} 
                                        inputPlaceholder={t("enter_details")} 
                                        setTextarea={(val) => handelUpdate(val, "description", key)}
                                    />
                                </div>
                            </div>
                            <div className="flex justify-end mt-4">
                                <ActionButton 
                                    isAdd={key === 0} 
                                    onClick={key === 0 ? addRow : () => removeRow(key)}
                                />
                            </div>
                        </div>
                        ))
                    }
                    </div>
                </div>
            </div>
        </div>

        {/* Action Plan Section */}        
        <div className={`bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden`}>
            <div className="bg-gradient-to-r from-teal-500 to-teal-600 px-6 py-4">
                <h3 className="text-white font-semibold text-lg flex items-center">
                <i className={`fa-light fa-tasks mr-3 text-xl`}></i>
                {t("action_plan")}
                </h3>
            </div>
            <div className="p-6 space-y-6">
                {actionPlan &&
                    actionPlan.map((item, index) => (
                    <div key={index} className="bg-slate-50 rounded-lg p-4 border-l-4 border-teal-500">
                        <div className="flex items-center justify-between mb-4">
                        <h4 className="font-semibold text-slate-800 flex items-center">
                            <span className="w-6 h-6 bg-teal-500 text-white rounded-full flex items-center justify-center text-sm mr-2">
                            {index + 1}
                            </span>
                            {t("action_item", "Action Item")}
                        </h4>
                        <ActionButton 
                            isAdd={index === 0} 
                            onClick={index === 0 ? addActionRow : () => removeActionRow(index)}
                        />
                        </div>
                        
                        <div className="mb-4">
                        <Input 
                            label={t("action_title", "Action Title")} 
                            labelClasses={"!text-sm font-medium text-slate-700"} 
                            inputType={"text"} 
                            inputPlaceholder={t("enter_title")} 
                            inputValue={item?.title} 
                            setInput={(val) => handelActionUpdate(val, "title", index)}
                        />
                        </div>

                        {item.subTitle &&
                        item.subTitle.length > 0 &&
                        item.subTitle.map((itm, indx) => (
                            <div key={indx} className="bg-white rounded-lg border border-slate-200 p-4 mb-3 ml-4">
                            <div className="grid sm:grid-cols-2 gap-4">
                                <div className="w-full">
                                {/* <Textarea 
                                    label={t("responsibility")} 
                                    labelClasses={"!text-sm font-medium text-slate-700"} 
                                    inputValue={itm?.responsibility} 
                                    inputPlaceholder={t("enter_responsibility")} 
                                    setTextarea={(val) => handelSubActionUpdate(index, val, "responsibility", indx)}
                                    inputClasses="focus:ring-2 focus:ring-teal-500 focus:border-teal-500"                                    
                                /> */}
                                <Editor
                                    apiKey={tinymceApiKey()}
                                    onInit={(evt, editor) => (editorRef.current = editor)}
                                    value={itm?.responsibility}
                                    name={"description"}
                                    init={{
                                    height: 200,
                                    menubar: false,
                                    plugins: [
                                        "code",
                                        "advlist autolink lists link image charmap print preview anchor",
                                        "searchreplace visualblocks code fullscreen",
                                        "insertdatetime media table paste code help wordcount",
                                    ],
                                    toolbar:
                                        "code | undo redo | formatselect | " +
                                        "bold italic backcolor | alignleft aligncenter " +
                                        "alignright alignjustify | bullist numlist outdent indent | " +
                                        "removeformat | help ",
                                    content_style:
                                        "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                                    }}
                                    onEditorChange={(newText) => handelSubActionUpdate(index, newText, "responsibility", indx)}
                                    wrapperClassName={"wrapperClassName"}
                                />
                                </div>
                                <div className="w-full">
                                <Textarea 
                                    label={t("responsible_party")} 
                                    labelClasses={"!text-sm font-medium text-slate-700"} 
                                    inputValue={itm?.responsible_party} 
                                    inputPlaceholder={t("enter_responsible_party")} 
                                    setTextarea={(val) => handelSubActionUpdate(index, val, "responsible_party", indx)}
                                    inputClasses="focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
                                />
                                </div>
                            </div>
                            <div className="flex justify-end mt-4">
                                <ActionButton 
                                isAdd={indx === 0} 
                                onClick={indx === 0 ? () => addSubActionRow(index) : () => removeSubActionRow(index, indx)}
                                />
                            </div>
                            </div>
                        ))
                        }
                    </div>
                    ))
                }
            </div>
        </div>

        {/* External Recruitment Section */}        
        <div className={`bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden`}>
            <div className="bg-gradient-to-r from-teal-500 to-teal-600 px-6 py-4">
                <h3 className="text-white font-semibold text-lg flex items-center">
                <i className={`fa-light fa-users mr-3 text-xl`}></i>
                {t("external_recruitment_plan", "External Recruitment Plan - President/CEO")}
                </h3>
            </div>
            <div className="p-6 space-y-6">
                <div className="space-y-6">
                    <div className="bg-slate-50 rounded-lg p-4">
                    <Textarea 
                        label={t("external_recruitment_description", "External Recruitment Description")} 
                        labelClasses={"!text-sm font-medium text-slate-700"} 
                        inputValue={externalRecruitment} 
                        inputPlaceholder={t("enter_details")} 
                        setTextarea={setExternalRecruitment}
                    />
                    </div>

                    {externalRecruitmentOptions &&
                    externalRecruitmentOptions.map((item, index) => (
                        <div key={index} className="bg-white rounded-lg border border-slate-200 p-4 hover:shadow-md transition-shadow duration-200">
                        <div className="flex items-center gap-4 mb-4">
                            <div className="flex-1">                           
                                <Editor
                                    apiKey={tinymceApiKey()}
                                    onInit={(evt, editor) => (editorRef.current = editor)}
                                    value={item?.title}
                                    name={"description"}
                                    init={{
                                    height: 200,
                                    menubar: false,
                                    plugins: [
                                        "code",
                                        "advlist autolink lists link image charmap print preview anchor",
                                        "searchreplace visualblocks code fullscreen",
                                        "insertdatetime media table paste code help wordcount",
                                    ],
                                    toolbar:
                                        "code | undo redo | formatselect | " +
                                        "bold italic backcolor | alignleft aligncenter " +
                                        "alignright alignjustify | bullist numlist outdent indent | " +
                                        "removeformat | help ",
                                    content_style:
                                        "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                                    }}
                                    onEditorChange={(newText) => handelExternalRecruitmentUpdate(newText, "title", index)}
                                    wrapperClassName={"wrapperClassName"}
                                />
                            </div>
                            <div className="flex items-center space-x-2">
                            <Checkbox
                                checkboxLabel={t("has_responsibilities", "Has Responsibilities")}
                                checkboxLableClass={"text-sm font-medium text-slate-700"}
                                isChecked={item?.isResponsibility}
                                checkboxValue={index}
                                getCheckboxValue={(code, event) => {
                                handelCheckbox(code, event);
                                }}
                            />
                            <ActionButton 
                                isAdd={index === 0} 
                                onClick={index === 0 ? addExternalRecruitmentRow : () => removeExternalRecruitmentRow(index)}
                            />
                            </div>
                        </div>

                        {item?.isResponsibility &&
                            item.subTitle &&
                            item.subTitle.length > 0 &&
                            item.subTitle.map((itm, indx) => (
                            <div key={indx} className="bg-slate-50 rounded-lg border border-slate-200 p-4 mb-3 ml-4">
                                <div className="grid sm:grid-cols-2 gap-4">
                                <div className="w-full">                                    
                                    <Editor
                                        apiKey={tinymceApiKey()}
                                        onInit={(evt, editor) => (editorRef.current = editor)}
                                        value={itm?.responsibility}
                                        name={"description"}
                                        init={{
                                        height: 200,
                                        menubar: false,
                                        plugins: [
                                            "code",
                                            "advlist autolink lists link image charmap print preview anchor",
                                            "searchreplace visualblocks code fullscreen",
                                            "insertdatetime media table paste code help wordcount",
                                        ],
                                        toolbar:
                                            "code | undo redo | formatselect | " +
                                            "bold italic backcolor | alignleft aligncenter " +
                                            "alignright alignjustify | bullist numlist outdent indent | " +
                                            "removeformat | help ",
                                        content_style:
                                            "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                                        }}
                                        onEditorChange={(newText) => handelSubExternalRecruitmentUpdate(index, newText, "responsibility", indx)}
                                        wrapperClassName={"wrapperClassName"}
                                    />
                                </div>
                                <div className="w-full">
                                    <Textarea 
                                    label={t("responsible_party")} 
                                    labelClasses={"!text-sm font-medium text-slate-700"} 
                                    inputValue={itm?.responsible_party} 
                                    inputPlaceholder={t("enter_responsible_party")} 
                                    setTextarea={(val) => handelSubExternalRecruitmentUpdate(index, val, "responsible_party", indx)}
                                    inputClasses="focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
                                    />
                                </div>
                                </div>
                                <div className="flex justify-end mt-4">
                                <ActionButton 
                                    isAdd={indx === 0} 
                                    onClick={indx === 0 ? () => addSubExternalRecruitmentRow(index) : () => removeSubExternalRecruitmentRow(index, indx)}
                                />
                                </div>
                            </div>
                            ))
                        }
                        </div>
                    ))
                    }
                </div>
            </div>
        </div>

        {/* Guidelines Section */}        
        <div className={`bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden`}>
            <div className="bg-gradient-to-r from-teal-500 to-teal-600 px-6 py-4">
                <h3 className="text-white font-semibold text-lg flex items-center">
                <i className={`fa-light fa-search mr-3 text-xl`}></i>
                {t("guidelines_for_selecting_a_search_firm")}
                </h3>
            </div>
            <div className="p-6 space-y-6">
                {guidelines &&
                    guidelines.map((itm, ind) => (
                    <div key={ind} className="bg-white rounded-lg border border-slate-200 p-4 mb-4 hover:shadow-md transition-shadow duration-200">
                        <div className="flex items-start gap-4">
                        <div className="flex-1">
                            <Textarea 
                                label={`${t("guideline")} ${ind + 1}`} 
                                labelClasses={"!text-sm font-medium text-slate-700"} 
                                inputValue={itm} 
                                inputPlaceholder={t("enter_details")} 
                                setTextarea={(val) => handelGuidelines(val, ind)}
                            />                            
                        </div>
                        <div className="flex items-center mt-6">
                            <ActionButton 
                                isAdd={ind === 0} 
                                onClick={ind === 0 ? addGuidelinesRow : () => removeGuidelinesRow(ind)}
                            />
                        </div>
                        </div>
                    </div>
                    ))
                }
            </div>
        </div>

        {/* Enhanced Save Section */}
        <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <div className="w-8 h-8 bg-teal-100 rounded-full flex items-center justify-center mr-3">
                <i className="fa-light fa-save text-teal-600"></i>
              </div>
              <div>
                <h4 className="font-semibold text-slate-800">{t("save_changes", "Save Changes")}</h4>
                <p className="text-sm text-slate-600">{t("save_your_emergency_plan", "Save your emergency replacement plan")}</p>
              </div>
            </div>
            
            <div className="flex items-center gap-4">
              <Button 
                buttonClasses={`!bg-teal-500 hover:!bg-teal-600 !px-6 !py-3 !text-base font-semibold transition-all duration-200 hover:shadow-lg ${isManage ? 'opacity-75 cursor-not-allowed' : ''}`} 
                buttonLabelClasses="text-white" 
                buttonType={"button"} 
                buttonIcon={isManage ? "fa-light fa-spinner fa-spin" : "fa-light fa-check"} 
                buttonIconPosition={"left"} 
                buttonLabel={t("save")} 
                functions={() => onSubmit()} 
                buttonHasLink={false} 
                buttonDisabled={isManage} 
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ManageEmergencyReplacementPlan;